import AdminRouteSelector, { AdminRoute } from "@app/components/admin-route-selector.tsx";
import { Box } from "@mui/material";
import { createFileRoute, Outlet } from "@tanstack/react-router";

const routes: AdminRoute[] = [
    { to: "/admin/assignment/billing-terms", name: "Billing Terms" },
    { to: "/admin/assignment/extensions", name: "Extensions" },
    { to: "/admin/assignment/invoice-print-styles", name: "Invoice Print Styles" },
    { to: "/admin/assignment/invoice-types", name: "Invoice Types" },
    { to: "/admin/assignment/utilization-codes", name: "Utilization Codes" },
    { to: "/admin/assignment/work-locations", name: "Work Locations" },
    { to: "/admin/assignment/wp-role-codes", name: "WP Role Codes" },
];

export const Route = createFileRoute("/_authenticated/_admin/admin/assignment")({
    component: Component,
});

function Component() {
    return (
        <>
            <AdminRouteSelector routes={routes} />
            <Box width={"100%"} mt={2}>
                <Outlet />
            </Box>
        </>
    );
}
